import React from 'react';
import { get } from 'lodash';

const OptionLine = ({ option }) => {
  const price =
    get(option, 'msrpDisplay.amount.text') ||
    get(option, 'msrpDisplay.display');
  return (
    <div className="math-box-option-line">
      <span
        className="math-box-option-line__description hide-print"
        dangerouslySetInnerHTML={{ __html: option.description }}></span>
      <span
        className="math-box-option-line__description show-print"
        dangerouslySetInnerHTML={{
          __html: `${option.description}${
            option.code ? ` (${option.code})` : ''
          }`,
        }}></span>
      <span className="math-box-option-line__price">{price}</span>
    </div>
  );
};

const OptionsByLine = ({ selectedOptions }) => {
  const optionLines = selectedOptions.map((option) => {
    return <OptionLine key={option.code} option={option} />;
  });
  return <>{optionLines}</>;
};

export default OptionsByLine;
